import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const AlertErrorSolid24: FC<IconV2Props> = ({ icon, className }) => {
  return (
    <svg
      className={cn(s.svg24, `svg-icon--${icon}`, className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-icon={`${icon}-24`}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#AB2434" fillRule="nonzero">
          <path d="M12,3.5 C16.6944204,3.5 20.5,7.30557963 20.5,12 C20.5,16.6944204 16.6944204,20.5 12,20.5 C7.30557963,20.5 3.5,16.6944204 3.5,12 C3.5,7.30557963 7.30557963,3.5 12,3.5 Z M13,15.5 L11,15.5 L11,17.5 L13,17.5 L13,15.5 Z M13,7.5 L11,7.5 L11,13.5 L13,13.5 L13,7.5 Z" />
        </g>
      </g>
    </svg>
  );
};

export default AlertErrorSolid24;
